import React from "react";
import { createRoot } from "react-dom/client";

import "./index.css";

import App from "./App";

if (process.env.NODE_ENV === "development") {

  require("@clayui/css/lib/css/base.css"); // eslint-disable-line global-require

}

class WebComponent extends HTMLElement {

  connectedCallback() {

    const root = createRoot(this);

    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );

  }

}

const ELEMENT_ID = "dr-now-user-sign-up";

if (!customElements.get(ELEMENT_ID)) {

  customElements.define(ELEMENT_ID, WebComponent);

}
